import { API_TIMEOUT, TIMEOUT } from '../../config/config'
import { axiosInterceptors } from '../utils/httpClient'
import {
  isAuthenticated,
} from './auth'

let isRefreshing = false
let refreshSubscribers = []

// ฟังก์ชันสำหรับช่วยเก็บ Request ที่รออยู่เข้าคิว
const subscribeTokenRefresh = (cb) => {
  refreshSubscribers.push(cb)
}

// ฟังก์ชันสำหรับเคลียร์คิวและปล่อยทุกตัววิ่งต่อเมื่อได้ Token ใหม่แล้ว
const onRefreshed = (token) => {
  refreshSubscribers.map((cb) => cb(token))
  refreshSubscribers = []
}

export const doGet = (url) => {
  return axiosInterceptors
    .get(url, API_TIMEOUT)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return onError(error, 'get', url)
      //throw error
    })
}

export const doPost = (url, request) => {
  return axiosInterceptors
    .post(url, request, API_TIMEOUT)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return onError(error, 'post', url, request)
      // throw error
    })
}

export const doPostFiles = (url, request) => {
  return axiosInterceptors({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: request,
    timeout: TIMEOUT,
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return onError(error, 'postFiles', url, request)
      // throw error
    })
}

export const doPostJson = (url, request) => {
  return axiosInterceptors({
    method: 'post',
    url: url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: request,
    timeout: TIMEOUT,
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return onError(error, 'postJson', url, request)
      // throw error
    })
}

export const doPut = (url, request) => {
  return axiosInterceptors
    .put(url, request, API_TIMEOUT)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return onError(error, 'put', url, request)
      // throw error
    })
}

export const doPutFiles = (url, request) => {
  return axiosInterceptors({
    method: 'put',
    url: url,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: request,
    timeout: TIMEOUT,
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return onError(error, 'putFiles', url, request)
      // throw error
    })
}

export const doDelete = (url) => {
  return axiosInterceptors
    .delete(url, API_TIMEOUT)
    .then((response) => {
      return response.status
    })
    .catch((error) => {
      return onError(error, 'delete', url)
      // throw error
    })
}

export const doDeleteData = (url) => {
  return axiosInterceptors
    .delete(url, API_TIMEOUT)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return onError(error, 'delete', url)
      // throw error
    })
}

export const doDeleteBody = (url, request) => {
  return axiosInterceptors({
    method: 'delete',
    url: url,
    headers: {
      'Content-Type': 'application/json',
    },
    data: request,
    timeout: TIMEOUT,
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return onError(error, 'deleteBody', url, request)
      // throw error
    })
}

export const doDownload = (url) => {
  return axiosInterceptors({
    url: url,
    method: 'get',
    responseType: 'blob',
    timeout: TIMEOUT,
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return onError(error, 'download', url)
      // throw error
    })
}

export const doPostDownload = (url, request) => {
  return axiosInterceptors({
    url: url,
    method: 'post',
    responseType: 'blob',
    data: request,
    timeout: TIMEOUT,
  })
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      return onError(error, 'postDownload', url, request)
      // throw error
    })
}

const onError = async (error, method, url, request) => {
  if (error?.response?.status === 401) {
    // 1. ตรวจสอบและทำ Refresh Token ผ่านกลไกจัดคิว
    let isRelogin = await valivateRelogin(error)

    if (isRelogin) {
      // 2. เมื่อได้ Token ใหม่ชัวร์ๆ แล้ว ค่อยเรียกสวิตช์ยิงตาม Type (เอา setTimeout ออกได้เลย)
      return executeMethod(error, method, url, request)
    } else {
      throw error
    }
  } else {
    throw error
  }
}

//แยก Switch Case ออกมาเป็นฟังก์ชันแยก เพื่อให้โค้ดสะอาดและเรียกซ้ำง่ายขึ้น
const executeMethod = (error, method, url, request) => {
  switch (method) {
    case 'get':
      return doGet(url)
    case 'post':
      return doPost(url, request)
    case 'postFiles':
      return doPostFiles(url, request)
    case 'postJson':
      return doPostJson(url, request)
    case 'put':
      return doPut(url, request)
    case 'putFiles':
      return doPutFiles(url, request)
    case 'delete':
      return doDelete(url)
    case 'deleteBody':
      return doDeleteBody(url, request)
    case 'download':
      return doDownload(url)
    case 'postDownload':
      return doPostDownload(url, request)
    default:
      throw error
  }
}

export const handleError = async (error, dispatch, type, id, option) => {
  if (error?.response?.status === 401) {
    // 1. ตรวจสอบและทำ Refresh Token ผ่านกลไกจัดคิว
    let isRelogin = await valivateRelogin(error)

    if (isRelogin) {
      // 2. เมื่อได้ Token ใหม่ชัวร์ๆ แล้ว ค่อยเรียกสวิตช์ยิงตาม Type (เอา setTimeout ออกได้เลย)
      return executeDispatchMethod(error, dispatch, type, id, option)
    } else {
      throw error
    }
  } else {
    throw error
  }
}

const valivateRelogin = async (error) => {
  // ตัวแรกที่วิ่งเข้ามา...
  if (!isRefreshing) {
    isRefreshing = true
    try {
      let refreshTokenSuccess = await isAuthenticated()
      if (refreshTokenSuccess) {
        isRefreshing = false
        onRefreshed() // ปล่อยตัวอื่นที่เข้าคิวรออยู่ให้ทำงานต่อ
        return true
      } else {
        isRefreshing = false
        throw error
      }
    } catch (refreshError) {
      isRefreshing = false
      refreshSubscribers = []
      throw refreshError
    }
  }

  // ตัวที่ 2, 3, 4... ที่วิ่งมาชนช่วงเวลาที่กำลัง Refresh อยู่ จะมาติดสัญญารอตรงนี้
  return new Promise((resolve) => {
    subscribeTokenRefresh(() => {
      resolve(true) // เมื่อตัวแรกเสร็จ จะสั่ง resolve ปลดล็อกให้ตัวนี้วิ่งต่อ
    })
  })
}

// ย้าย Switch Case ของ Dispatch ออกมาข้างนอกให้โค้ดสะอาดขึ้น
const executeDispatchMethod = async (error, dispatch, type, id, option) => {
  switch (type) {
    case 'subProject':
      await dispatch(getSchemaSubProjectSidebar(id))
      break
    case 'multiAprove':
      await dispatch(getSchemaMultiAproveSidebar(id, option))
      break
    case 'multiReview':
      await dispatch(getSchemaMultiReviewSidebar(id))
      break
    case 'multiApproveReviewer':
      await dispatch(getSchemaMultiApproveReviewerSidebar(id))
      break
    case 'sidebar':
      await dispatch(getSchemaSidebar(id))
      break
    case 'legalManagement':
      await dispatch(getSchemaLegalManagementSidebar())
      break
    case 'dataManagement':
      await dispatch(getSchemaDataManagementSidebar())
      break
    case 'accounting':
      await dispatch(getSchemaAccountingSidebar())
      break
    case 'accountingIE':
      await dispatch(getSchemaAccountingIncomExpenseSidebar())
      break
    case 'accountingApprover':
      await dispatch(getSchemaAccountingApproverSidebar())
      break
    case 'assessmentMenu':
      await dispatch(getAssessmentMenuSidebar())
      break
    default:
      throw error
  }
}
